import { render, staticRenderFns } from "./iframeDialog.vue?vue&type=template&id=ffe1ea1a&scoped=true&"
import script from "./iframeDialog.vue?vue&type=script&lang=js&"
export * from "./iframeDialog.vue?vue&type=script&lang=js&"
import style0 from "./iframeDialog.vue?vue&type=style&index=0&id=ffe1ea1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe1ea1a",
  null
  
)

export default component.exports